import React, {useState} from 'react'
import { useStyle } from "./Style";
import Grid from "@material-ui/core/Grid";
import { TextValidator, ValidatorForm, SelectValidator, } from 'react-material-ui-form-validator';
import MenuItem from "@mui/material/MenuItem";

const DisabilityClaimDetails = (props) => {
  const classes = useStyle();
  const [type_of_disability, setTypeOfDisability] = useState(props.claimState.type_of_disability || '');
  const [attendingPhysician, setAttendingPhysician] = useState(props.claimState.attending_physician || '');

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "dateOfDamage") {
      handleSubmit(value)
    }

  }


  const handleSubmit = (value) => {

    const tempClaimInitiation = props.claimInitiationPayload;
    tempClaimInitiation["additional_details"] = {
      "device_number": props.eventData.additional_details.device_number
    };
    props.setClaimInitiationPayload(tempClaimInitiation);
  }



  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <div className={classes.headingclaim}>
            <h4> Details</h4>
          </div>
        </Grid>
      </Grid>
      <ValidatorForm onSubmit={() => { }}>
        <Grid container spacing={2} className={classes.selectpolicyWrapper}>
          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="name"
              style={{ width: "100%" }}
              label="first_name"
              name='first_name'
              value={props.member.first_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="middle_name"
              style={{ width: "100%" }}
              label="middle_name"
              name='middle_name'
              value={props.member.middle_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="last_name"
              style={{ width: "100%" }}
              label="last_name"
              name='last_name'
              value={props.member.last_name}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="relationship"
              style={{ width: "100%" }}
              label="relationship"
              name='relationship'
              value={props.member.relationship}
              onChange={handleChange}
              variant="outlined"
            />
          </Grid>

          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="gender"
              style={{ width: "100%" }}
              label="gender"
              name='gender'
              value={props.member.gender}
              variant="outlined"
            />
          </Grid>



          <Grid item xs={12} md={4} sm={4}>
            <TextValidator
              id="date_of_birth"
              style={{ width: "100%" }}
              label="date_of_birth"
              name='date_of_birth'
              value={props.member.date_of_birth}
              variant="outlined"
            />
          </Grid>


        </Grid>

        <hr />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <div className={classes.headingclaim}>
              <h4>Date Declared Disable </h4>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={2} className={classes.selectpolicyWrapper}>



          <Grid item xs={12} sm={4} md={4}>
            <TextValidator
              id="dateOfDisability"
              label="Date Of Disability"
              name='dateOfDisability'
              value={props.claimInitiationPayload.event_date}
              disabled
              style={{ width: "100%" }}
              fullWidth
              type='date'
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
            />
          </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <SelectValidator
                labelId="type_of_disability"
                id="type_of_disability"
                value={type_of_disability}
                name="type_of_disability"
                type="text"
                label="Select Type of Disability"
                onChange={(e) => {
                  setTypeOfDisability(e.target.value);
                  props.setAdditionalState("type_of_disability", e.target.value);
                }}
                variant="outlined"
                validators={["required"]}
                errorMessages={["Please select type of disability"]}
                style={{ width: "100%" }}
                sx={{
                  fontFamily: "Open Sans",
                  fontStyle: "normal",
                  fontWeight: 300,
                  fontSize: "12px",
                  lineHeight: "16px",
                  letterSpacing: "0.005em",
                  color: "#000000",
                }}
              >
                {["Permanent", "Partial Permanent"].map((cause, index) => {
                  return (
                    <MenuItem
                      key={index}
                      sx={{
                        fontFamily: "Open Sans",
                        fontStyle: "normal",
                        fontWeight: 300,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0.005em",
                        color: "#000000",
                      }}
                      value={cause}
                    >
                      {cause}
                    </MenuItem>
                  );
                })}
              </SelectValidator>
            </Grid>

             <Grid item xs={12} sm={4} md={4}>
            <TextValidator
              id="attending_physician"
              label="Attending Physician"
              name="attending_physician"
              value={attendingPhysician}
              onChange={(e) => {
                setAttendingPhysician(e.target.value);
                props.setAdditionalState("attending_physician", e.target.value);
              }}
              style={{ width: "100%" }}
              variant="outlined"
            />
          </Grid>


        </Grid>

      </ValidatorForm>
    </>
  )
}

export default DisabilityClaimDetails

